// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import vhanBadgeSrc from 'images/VHAN_badge.png';
import classes from './GroupStatusIndicator.module.scss';

const GREEN = '#097d37';
const RED = '#bc1d09';

/** @typedef {{
  hasGroup: boolean,
  enteredByGuest: boolean,
  enteredByReceiver: boolean,
  isInGroup: boolean,
  isVhan?: boolean,
  small?: boolean
}} GroupStatusIndicatorPropsType */

/** @type { React.FC<GroupStatusIndicatorPropsType> } */
const GroupStatusIndicator = ({
  isVhan,
  hasGroup,
  enteredByGuest,
  enteredByReceiver,
  isInGroup,
  small,
}) =>
  hasGroup && !enteredByReceiver && !enteredByGuest ? (
    <h5
      className={cx(classes.GroupStatusIndicator, { [classes.small]: small })}
      style={{ color: isInGroup ? GREEN : RED }}
    >
      {isInGroup ? (
        !!isVhan ? (
          <div className={classes.vhan_badge_container}>
            <img src={vhanBadgeSrc} alt="VHAN Participant" />
          </div>
        ) : (
          'In Network'
        )
      ) : (
        'Out of Network'
      )}
    </h5>
  ) : null;

GroupStatusIndicator.displayName = 'GroupStatusIndicator';

GroupStatusIndicator.propTypes = {
  hasGroup: PropTypes.bool.isRequired,
  isInGroup: PropTypes.bool.isRequired,
  small: PropTypes.bool.isRequired,
};

GroupStatusIndicator.defaultProps = {
  small: false,
};

export default GroupStatusIndicator;
